import React, {useContext} from 'react'
import { faChevronDown, faCircleChevronDown, faUserCircle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import AppContext from '../contexts/AppContext'
import SearchBar from '../components/SearchBar'


function NavBarLayout({title}) {
    const {user, sidebarOpen, navHeaderText, setsidebarOpen} = useContext(AppContext)

  return (
    <div style={{fontFamily: 'Roboto'}} className={`items-center justify-between top-0 w-full relative shadow-lg transition-all ease-linear duration-300`}>
        <div className='  bg-white flex items-center justify-between p-1 px-5'>
            <div className='flex items-center justify-center gap-2'>
                <button className={`mx-3 border border-2 border-gray-300 hover:shadow-md hover:shadow-teal-500/20 p-2 rounded-md ${sidebarOpen?'hidden':''}`} onClick={()=>setsidebarOpen(!sidebarOpen)}>
                    <svg fill="currentColor" viewBox="0 0 16 16" height="30" width="30">
                        <path fillRule="evenodd" d="M2.5 12a.5.5 0 01.5-.5h10a.5.5 0 010 1H3a.5.5 0 01-.5-.5zm0-4a.5.5 0 01.5-.5h10a.5.5 0 010 1H3a.5.5 0 01-.5-.5zm0-4a.5.5 0 01.5-.5h10a.5.5 0 010 1H3a.5.5 0 01-.5-.5z"/>
                    </svg>
                </button>
                <div className=''>
                    <img src={require('../assets/RAFCE-logo-black.png')} alt='logo' style={{height: '5rem'}} />
                </div>
                {/* <div className='mt-5 relative -left-[20px] text-sm'>RAFCE</div> */}

                <div className='ml-32 font-bold uppercase'>
                    {/* <SearchBar /> */}
                    {navHeaderText}
                </div>
            </div>
            

            

            <div className='flex items-center justify-end gap-2'>
                <div className=''>
                    <button className='mt-1 text-slate-800 border-2 border-slate-300 rounded-full p-1'>
                        <svg viewBox="0 0 512 512" fill="currentColor" height="20" width="20">
                            <path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={32} d="M427.68 351.43C402 320 383.87 304 383.87 217.35 383.87 138 343.35 109.73 310 96c-4.43-1.82-8.6-6-9.95-10.55C294.2 65.54 277.8 48 256 48s-38.21 17.55-44 37.47c-1.35 4.6-5.52 8.71-9.95 10.53-33.39 13.75-73.87 41.92-73.87 121.35C128.13 304 110 320 84.32 351.43 73.68 364.45 83 384 101.61 384h308.88c18.51 0 27.77-19.61 17.19-32.57zM320 384v16a64 64 0 01-128 0v-16"/>
                        </svg>
                    </button>
                </div>
                <div className=''>
                    <button className='mt-1 text-slate-800 border-2 border-slate-300 rounded-full p-1'>
                        <svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} viewBox="0 0 24 24" height="20" width="20">
                                <path d="M15 12 A3 3 0 0 1 12 15 A3 3 0 0 1 9 12 A3 3 0 0 1 15 12 z" />
                                <path d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 010 2.83 2 2 0 01-2.83 0l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-2 2 2 2 0 01-2-2v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83 0 2 2 0 010-2.83l.06-.06a1.65 1.65 0 00.33-1.82 1.65 1.65 0 00-1.51-1H3a2 2 0 01-2-2 2 2 0 012-2h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 010-2.83 2 2 0 012.83 0l.06.06a1.65 1.65 0 001.82.33H9a1.65 1.65 0 001-1.51V3a2 2 0 012-2 2 2 0 012 2v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 0 2 2 0 010 2.83l-.06.06a1.65 1.65 0 00-.33 1.82V9a1.65 1.65 0 001.51 1H21a2 2 0 012 2 2 2 0 01-2 2h-.09a1.65 1.65 0 00-1.51 1z" />
                        </svg>
                    </button>
                </div>

                <div className={`${sidebarOpen?'mr-12':'mr-5'} flex items-center ml-10 transition-all ease-linear duration-300`}>
                    {/*<div className='mr-auto ml-16 text-lg '>{title}</div>*/}
                    <FontAwesomeIcon icon={faUserCircle} className='mr-1 bg-gray-500 text-white rounded-full border border-2 border-gray-300' size='2x'/>
                    {/* <div className='ml-5 mr-10 text-lg font-dmsans'>{user?.sub}</div> 
                    <div className='border border-gray-300 border-2 rounded-full h-8 w-8 flex items-center justify-center'>
                        <FontAwesomeIcon icon={faChevronDown} />
                    </div> */}
                </div>
                
            </div>

        </div>
             
    </div>
  )
}

export default NavBarLayout